export const FETCH_REFERENCE_REQUEST = 'FETCH_REFERENCE_REQUEST';
export const FETCH_REFERENCE_SUCCESS = 'FETCH_REFERENCE_SUCCESS';
export const FETCH_REFERENCE_FAILURE = 'FETCH_REFERENCE_FAILURE';